import { action } from 'typesafe-actions'
import { AdminUserDetail, AdminUserRoleUpdateRequest } from './admin-users'

export enum adminUsersActionType {
  SEARCH_ADMIN_USER_REQUEST = 'SEARCH_ADMIN_USER_REQUEST',
  SEARCH_ADMIN_USER_SUCCESS = 'SEARCH_ADMIN_USER_SUCCESS',
  UPDATE_ADMIN_USER_ROLE_REQUEST = 'UPDATE_ADMIN_USER_ROLE_REQUEST',
  UPDATE_ADMIN_USER_ROLE_SUCCESS = 'UPDATE_ADMIN_USER_ROLE_SUCCESS',
  RESET_ADMIN_USERS = 'RESET_ADMIN_USERS',
  THROW_ERROR = 'THROW_ERROR',
}

export const adminUsersActions = {
  searchAdminUserRequest: (email: string) =>
    action(adminUsersActionType.SEARCH_ADMIN_USER_REQUEST, { email }),
  searchAdminUserSuccess: (user: AdminUserDetail) =>
    action(adminUsersActionType.SEARCH_ADMIN_USER_SUCCESS, { user }),
  updateAdminUserRoleRequest: (request: AdminUserRoleUpdateRequest) =>
    action(adminUsersActionType.UPDATE_ADMIN_USER_ROLE_REQUEST, { request }),
  updateAdminUserRoleSuccess: (user: AdminUserDetail) =>
    action(adminUsersActionType.UPDATE_ADMIN_USER_ROLE_SUCCESS, { user }),
  resetAdminUsers: () => action(adminUsersActionType.RESET_ADMIN_USERS),
  throwError: (error: Error) => action(adminUsersActionType.THROW_ERROR, { error }),
}